import { Box, Link, Typography } from "@material-ui/core";
import { FC } from "react";

const Disclaimer: FC<any> = () => {
  return (
    <Box mt={2} className="connect-wallet-res-checkbox">
      <Typography variant="subtitle1">
        By connecting wallet you agree to
        <Link
          href="https://www.gains-associates.com/terms&conditions"
          target="_blank"
          rel="noreferrer"
          className="text-decoration-none"
        >
          <Typography variant="subtitle1" component="span" className="fw-bold">
            {" "}
            Terms of Services
          </Typography>
        </Link>{" "}
        and
        <Link
          href="https://www.gains-associates.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="text-decoration-none"
        >
          <Typography variant="subtitle1" component="span" className="fw-bold">
            {" "}
            Privacy Policy
          </Typography>
        </Link>
      </Typography>
    </Box>
  );
};

export default Disclaimer;
